// src/components/NotificationDetailsModal.jsx

import { X } from "lucide-react";
import { useNotifications } from "../Context/NotificationContext";

const NotificationDetailsModal = () => {
    const { selectedNotification, setSelectedNotification } = useNotifications();

    if (!selectedNotification) return null;

    return (
        <div
            onClick={() => setSelectedNotification(null)}
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white p-5 rounded-lg shadow-lg w-80 md:w-96"
            >
                <div className="flex justify-between items-center border-b pb-2">
                    <h2 className="text-lg font-semibold">Notification Details</h2>
                    <button
                        onClick={() => setSelectedNotification(null)}
                        className="text-gray-600"
                    >
                        <X />
                    </button>
                </div>

                <div className="mt-4">
                    <p className="font-medium">{selectedNotification.title}</p>
                    <p className="text-gray-700 mt-2">{selectedNotification.message}</p>
                    <p className="text-xs text-gray-400 mt-3">
                        {selectedNotification.createdOnDate}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotificationDetailsModal;
